<template>
  <main class="premium-photo-redirect" aria-live="polite">
    <v-progress-circular indeterminate color="#d4af37" size="42" />
  </main>
</template>

<script>
export default {
  name: "PremiumPhotoExperience",
  mounted() {
    const reservationId = encodeURIComponent(this.$route.params.reservationId)
    window.location.replace(
      `/premium-photo-delivery/view.html?reservationId=${reservationId}`
    )
  },
}
</script>

<style scoped>
.premium-photo-redirect {
  display: grid;
  width: 100%;
  min-height: 100vh;
  background: #111;
  place-items: center;
}
</style>
